import React, { useEffect, useState } from 'react';

// import '../../../Assets/css/product_list.css';
import Filter from '../filter/Filter';
import Productlist from './Product_list';
import { Helmet } from 'react-helmet';
import { useSelector } from 'react-redux';
import CustomBanner from './CustomBanner';


const Product_list = () => {
  
 
  const ifbanner = useSelector((state) => state?.persistedReducer?.meta?.meta);
  const [filtercall, setFiltercall] = useState(false);
  
// const pathname= window.location.pathname;
//   useEffect(()=>{
//     if(pathname.includes("gift-250") || pathname.includes("gift-500")){
//       setFiltercall(true);
//     }
//   },[pathname])
  return (
    <>
    {/* {ifbanner.banner !== null && <Banner1 data={ifbanner} />} */}
  
      {/* <Banner /> */}
      <CustomBanner/>
     

      <div className='container_productList'>
        <Filter filtercall={() => setFiltercall(true)} />
        <Productlist filtercall={filtercall} />
      </div>
    </>
  )
}

export default Product_list;